module.exports = __webpack_public_path__ + "assets/img/bottom_bg.d2cb2c8b.png";